import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    TableContainer
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME, salesDepartment } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "white",

    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        // "&:hover": { 
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    }
}));

// const useStyles = makeStyles({
//     stageHeader: {
//         backgroundColor: 'blue',
//         color: 'white',
//         textAlign: 'center',
//         position: 'sticky',
//         left: 0,
//         zIndex: 9,
//     },
//     weekHeader: {
//         backgroundColor: 'blue',
//         color: 'white',
//         textAlign: 'center',
//         position: 'sticky',
//         top: 0,
//         zIndex: 1,
//         borderBottom: '1px solid black',
//     },
//     countValueCell: {
//         backgroundColor: 'white',
//         color: 'blue',
//         textAlign: 'center',
//         borderRight: '1px solid gray',
//         cursor: 'pointer',
//     },
//     finalBorder: {
//         borderRight: '1px solid black',
//     },
//     tableContainer: {
//         maxHeight: '500px',
//         overflow: 'auto',
//     },
//     table: {
//         minWidth: '600px',
//     }
// });

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const MonthlyContractReview = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const [stagesData, setStagesData] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [pivot, setPivot] = useState("monthlyContractReview")
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    // const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [status, setStaus] = useState('');
    const [selectLost, setSeletLost] = useState('')
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    const [showAllStages, setShowAllStages] = useState(false);
    const [selectedMonths, setSelectedMonths] = useState("");

    // Function to toggle dropdown visibility
    const toggleDropdown = () => {
        setShowAllStages(!showAllStages);
    };

    // Filtered data to show
    const filteredStages = showAllStages
        ? stagesData
        : stagesData.filter(stage => stage.stage === 'Projected Numbers' || stage.stage === 'Revised Numbers' || stage.stage === "Slip Ons");


    useEffect(() => {
        expCenters();
        locations();
        fetchUsersData();
        monthlyContractReview();
        if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            monthlyContractReview()
            setSelectedRole(ROLENAME.DesignUser)
        } else {
            monthlyContractReview()
            setSelectedRole("ALL")
        }
    }, []);
    const months = [
        { label: 'January', value: 1 },
        { label: 'February', value: 2 },
        { label: 'March', value: 3 },
        { label: 'April', value: 4 },
        { label: 'May', value: 5 },
        { label: 'June', value: 6 },
        { label: 'July', value: 7 },
        { label: 'August', value: 8 },
        { label: 'September', value: 9 },
        { label: 'October', value: 10 },
        { label: 'November', value: 11 },
        { label: 'December', value: 12 }
    ];
    // const generateMonthsWithYears = () => {
    //     const currentYear = new Date().getFullYear();
    //     const nextYear = currentYear + 1;
    //     const months = [
    //         'January', 'February', 'March', 'April', 'May', 'June',
    //         'July', 'August', 'September', 'October', 'November', 'December'
    //     ];

    //     let options = [];
    //     for (let year of [currentYear, nextYear]) {
    //         months.forEach((month, index) => {
    //             options.push({ label: `${month} ${year}`, value: { month: index + 1, year } });
    //         });
    //     }

    //     return options;
    // };

    // const monthsWithYears = generateMonthsWithYears();
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "value", label: "Value" },
        { key: "currentStage", label: "Current Stage" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "projectedDesignSignOffDate", label: "Projected Design Sign-Off Date" },
        { key: "revisedProjectedDesignSignOffDate", label: "Revised Projected Design Sign-Off Date" },
        { key: "designDGM", label: "DGM" },
        { key: "designManager", label: "Operation Design Manager" },
        { key: "designAssistantManager", label: "ADM" },
        { key: "designUser", label: "Designer" },
    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: popMonthData[i]?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.lead_no || "N/A",
                    clientName: popMonthData[i]?.customerId?.name,
                    value: popMonthData[i]?.staticSalesWonBudget || "N/A",
                    location: popMonthData[i]?.experienceCenterId?.locationId?.name,
                    expCtrName: popMonthData[i]?.experienceCenterId?.name,
                    salesWonDate: popMonthData[i]?.leadWonDate
                        ? moment(popMonthData[i]?.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    currentStage: popMonthData[i]?.currentStage ? popMonthData[i]?.currentStage : 'NA',
                    projectedDesignSignOffDate: popMonthData[i]?.projectedDesignSignOffDate?.before10th
                        ? moment(popMonthData[i].projectedDesignSignOffDate.before10th).format("DD-MM-YYYY")
                        : popMonthData[i]?.projectedDesignSignOffDate?.committedDate
                            ? moment(popMonthData[i].projectedDesignSignOffDate.committedDate).format("DD-MM-YYYY")
                            : "-",
                    revisedProjectedDesignSignOffDate: popMonthData[i]?.projectedDesignSignOffDate.after10th
                        ? moment(popMonthData[i]?.projectedDesignSignOffDate.after10th).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    designDGM: popMonthData[i]?.designDGM ? popMonthData[i]?.designDGM?.name : 'NA',
                    designManager: popMonthData[i]?.designManager ? popMonthData[i]?.designManager?.name : 'NA',
                    designAssistantManager: popMonthData[i]?.designAssistantManager ? popMonthData[i]?.designAssistantManager?.name : 'NA',
                    designUser: popMonthData[i]?.designUser ? popMonthData[i]?.designUser?.name : 'NA',
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     clientName: "",
                //     totalValue: "",
                //     expCtrName: "",
                //     salesWonDate: "",
                //     projectedDesignSignOffDate: "",
                //     revisedProjectedDesignSignOffDate: "",
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };
    const expCenterData = {};
    stagesData.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(stagesData.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(stagesData.map((el) => el.experienceCenterName)));


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const monthlyContractReview = async (addLocation, addExpCenter, selectedMonths, usersData, selectedSearchType, searchInput) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        // let monthsData = selectedMonths?.map((el) => el.label)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedMonths: selectedMonths ? selectedMonths.label : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            selectedLocation: locationData ? locationData : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        props.setLoading(true);
        try {
            let response = await HttpService.monthlyContractReviewDashBoard(obj);
            setStagesData(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        monthlyContractReview(selectedLocation, selectedExperienceCenter, selectedMonths, selectedUsers, selectedSearchType, searchInput)
    }

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (value) => {
        monthlyContractReview(selectedLocation, selectedExperienceCenter, selectedMonths, selectedUsers, selectedSearchType, searchInput)
    }
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        handleExpData(newvalue)
    }
    const handleExpData = async (newvalue) => {
        props.setLoading(true);
        await monthlyContractReview(selectedLocation, newvalue, selectedMonths, selectedUsers, selectedSearchType, searchInput)
        props.setLoading(false);
    }


    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
        handleLocationData(newValue)
    }
    const handleLocationData = async (newValue) => {
        props.setLoading(true);
        await monthlyContractReview(newValue, selectedExperienceCenter, selectedMonths, selectedUsers, selectedSearchType, searchInput)
        props.setLoading(false);
    }

    const handleMonthChange = async (event, value) => {
        setSelectedMonths(value)
        await monthlyContractReview(selectedLocation, selectedExperienceCenter, value, selectedUsers, selectedSearchType, searchInput)
    };

    const getDataBasedClickMonthlyContractReview = async (e, week, stage) => {
        let users = ''
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let locationData =
            selectedLocation && selectedLocation.length > 0
                ? selectedLocation.map((el) => el._id)
                : "";
        if (selectedUsers && selectedUsers.length !== 0) {
            users = selectedUsers?.map((el) => el._id)
        }
        let obj = {
            selectedMonths: selectedMonths,
            stage: stage.stage,
            weekNumber: week.weekLabel,
            selectedRole: selectedRole ? selectedRole : "",
            users: users ? users : "",
            selectedExperienceCenter: expCenterData.length !== 0 ? expCenterData : "",
            selectedLocation: locationData.length !== 0 ? locationData : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput !== "" ? searchInput.toUpperCase() : ""
        }
        props.setLoading(true);
        try {
            let response = await HttpService.getDataBasedClickMonthlyContractReview(obj);
            setPopMonthData(response.data)
            setShowDetailedModal(true)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const handleSelectRoles = async (event, role) => {
        setSelectedUsers([])
        let obj = {}
        if (role) {
            obj.role = role
        } else {
            setSelectedRole(event.target.value)
            obj.role = event.target.value
        }
        obj.pivotValue = pivot
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            if (!role) {
                await monthlyContractReview(selectedLocation, selectedExperienceCenter, selectedMonths, obj, selectedSearchType, searchInput)
            }
            setUsersData(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }

    const fetchUsersData = async () => {
        let obj = {
            role: ROLENAME.DesignUser
        }
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            setUsersData(response.data)
        } catch (error) {
            console.log(error, "error")
        }
    }

    const handleMultipleUsers = (e, newvalue) => {
        setSelectedUsers(newvalue)
        handleUsersData(newvalue)
    }

    const handleUsersData = async (newvalue) => {
        props.setLoading(true);
        let obj = {
            users: newvalue,
            role: selectedRole
        }
        await monthlyContractReview(selectedLocation, selectedExperienceCenter, selectedMonths, obj, selectedSearchType, searchInput)
        props.setLoading(false);
    }

    const clearDateFilter = () => {
        setSearchInput("")
        setSelectedSearchType("")
        monthlyContractReview(selectedLocation, selectedExperienceCenter, selectedMonths, selectedUsers, "", "")
    }

    return (
        <div className="App">
            <br />
            <div>
                <Paper className={classes.paper}>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%' }}>
                                <Autocomplete
                                    multiple
                                    value={selectedLocation}
                                    onChange={handleMultipleLocationData}
                                    options={commonLocation}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Location"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%' }}>
                                <Autocomplete
                                    multiple
                                    value={selectedExperienceCenter}
                                    onChange={handleMultipleExpData}
                                    options={commonExpCenter}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Exp-Center"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%' }}>
                                <Autocomplete
                                    id="fromMonths"
                                    options={months}
                                    getOptionLabel={(option) => option?.label || ""}
                                    value={selectedMonths}
                                    onChange={handleMonthChange}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Select Month"
                                            placeholder="Select Month"
                                            fullWidth
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Design].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={"ALL"}>ALL</MenuItem>
                                            <MenuItem value={ROLENAME.DGM_Design}>DGM</MenuItem>
                                            <MenuItem value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>
                                            <MenuItem value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>
                                            <MenuItem value={ROLENAME.DesignUser}>Designer</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.OperationDesignManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={2}>
                                    <FormControl style={{ width: '80%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>
                                            <MenuItem value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>
                                            <MenuItem value={ROLENAME.DesignUser}>Designer</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.AssistantDesignManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={4}>
                                    <FormControl style={{ width: '100%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>
                                            <MenuItem value={ROLENAME.DesignUser}>Designer</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            size="medium"
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            ListboxProps={{ style: { maxHeight: "15rem" }, position: "bottom-start" }}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}
                    </Grid>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ width: '80%' }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }}
                            className={classes.leadSearchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10 }}
                            className={classes.leadClearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>
            </div>
            <br />
            <div>
                <>
                    <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                        <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                            <Table style={{ minWidth: '600px' }}>
                                <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                    <StyledTableRow>
                                        {/* Stage Column */}
                                        <StyledTableCell className={classes.stageHeader} rowSpan={1}>
                                            Stage
                                        </StyledTableCell>

                                        {/* Week Labels */}
                                        {stagesData[0]?.weeklyData.map((week, index) => (
                                            <StyledTableCell
                                                key={index}
                                                className={classes.weekHeader}
                                            >
                                                <Tooltip title={`Week ${week.weekLabel}`} placement="top">
                                                    <span style={{ cursor: "pointer" }}>
                                                        {week.weekLabel}
                                                    </span>
                                                </Tooltip>
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                </TableHead>

                                {/* Table Rows for Stages */}

                                <TableBody>
                                    {filteredStages.map((stage, stageIndex) => (
                                        <StyledTableRow key={stageIndex}>
                                            {/* Stage Name */}
                                            <StyledTableCell className={classes.bordercolors}>
                                                {stage.stage}
                                            </StyledTableCell>

                                            {/* Count cells */}
                                            {stagesData[0]?.weeklyData.map((week, weekIndex) => {
                                                const weekData = stage.weeklyData.find(weekly => weekly.weekLabel === week.weekLabel);

                                                return (
                                                    <StyledTableCell
                                                        key={`count-${weekIndex}`}
                                                        className={classes.bordercolors}
                                                        style={{
                                                            textAlign: "center",
                                                            cursor: "pointer",
                                                            color: week.weekLabel === 'Completed' || week.weekLabel === "Committed" || week.weekLabel === 'Pending' ? "#355025" : "#1C375D",
                                                            fontWeight: week.weekLabel === 'Completed' || week.weekLabel === "Committed" || week.weekLabel === 'Pending' ? 'bold' : 'normal',
                                                            textDecoration: "underline",
                                                            background: "white"
                                                        }}
                                                        onClick={(e) => getDataBasedClickMonthlyContractReview(e, week, stage)}
                                                    >
                                                        {weekData?.count || 0}
                                                    </StyledTableCell>
                                                );
                                            })}
                                        </StyledTableRow>
                                    ))}

                                    {/* Toggle Button to Show/Hide Remaining Stages */}
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={stagesData[0]?.weeklyData.length + 1} style={{ textAlign: 'center' }}>
                                            <Button onClick={toggleDropdown} variant="outlined">
                                                {showAllStages ? 'Hide Stages' : 'Show Stages'}
                                            </Button>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </>
            </div>
            <Modal
                title={pivot}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={`${pivot}.csv`}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                {popMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Designer</StyledTableCell>
                                    <StyledTableCell>ADM</StyledTableCell>
                                    <StyledTableCell>Projected Design Sign-Off Date</StyledTableCell>
                                    <StyledTableCell>Revised Projected Design Sign-Off Date</StyledTableCell>
                                    <StyledTableCell>Current Stage</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popMonthData?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell>{i + 1}</StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >

                                                {
                                                    data?.erpProjectNo ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.erpProjectNo}</Link> :
                                                        'NA'
                                                }

                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {
                                                    data?.lead_no ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.lead_no}</Link> :
                                                        'NA'
                                                }

                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerId?.name}
                                            </StyledTableCell>
                                            {
                                                <>
                                                    <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                        {data?.staticSalesWonBudget?.toLocaleString("en-IN", {
                                                            maximumFractionDigits: 2, // Maximum number of decimal places
                                                            style: "currency",
                                                            currency: "INR",
                                                        })}
                                                    </StyledTableCell>
                                                </>
                                            }
                                            <StyledTableCell>
                                                {data?.experienceCenterId?.locationId?.name}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.experienceCenterId?.name}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.leadWonDate
                                                    ? moment(data?.leadWonDate).format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.designUser?.name ? data.designUser?.name : '-'}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.designAssistantManager?.name ? data.designAssistantManager?.name : '-'}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.projectedDesignSignOffDate?.before10th
                                                    ? moment(data.projectedDesignSignOffDate.before10th).format("DD-MM-YYYY")
                                                    : data?.projectedDesignSignOffDate?.committedDate
                                                        ? moment(data.projectedDesignSignOffDate.committedDate).format("DD-MM-YYYY")
                                                        : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.projectedDesignSignOffDate.after10th
                                                    ? moment(data?.projectedDesignSignOffDate.after10th).format(
                                                        "DD-MM-YYYY"
                                                    )
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.currentStage}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(MonthlyContractReview);